
import React from 'react';
import { ExternalLink } from "lucide-react";

interface SocialProfilesProps {
  linkedinUrl: string | null;
  twitterUrl: string | null;
  facebookUrl: string | null;
}

const SocialProfiles = ({ linkedinUrl, twitterUrl, facebookUrl }: SocialProfilesProps) => {
  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <p className="text-sm font-medium text-gray-500">Social Profiles</p>
      </div>
      <div className="space-y-2">
        {linkedinUrl && (
          <a 
            href={linkedinUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center space-x-2 text-sm text-blue-600 hover:text-blue-800"
          >
            <span>LinkedIn</span>
            <ExternalLink className="h-3 w-3" />
          </a>
        )}
        {twitterUrl && (
          <a 
            href={twitterUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center space-x-2 text-sm text-blue-600 hover:text-blue-800"
          >
            <span>Twitter</span>
            <ExternalLink className="h-3 w-3" />
          </a>
        )}
        {facebookUrl && (
          <a 
            href={facebookUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center space-x-2 text-sm text-blue-600 hover:text-blue-800"
          >
            <span>Facebook</span>
            <ExternalLink className="h-3 w-3" />
          </a>
        )}
        {!linkedinUrl && !twitterUrl && !facebookUrl && (
          <p className="text-sm text-gray-600">No social profiles available</p>
        )}
      </div>
    </div>
  );
};

export default SocialProfiles;
